<gs-generic-crud *ngIf="config" [configuration]="config"></gs-generic-crud>

